module.exports = __webpack_public_path__ + "img/A2.3.3.b66d5dac.png";